// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1934e64e","455":"4469d6f7","977":"4bf9f63b"}[chunkId] + ".chunk.js";
};